export const apiBaseUrl = "/api";
export const keepApiDataForHours = 1;
export const dateFormatDefault = "MM/DD/YYYY";
export const dateInvalid="Invalid Date";
export const earliestValidDate = "1900-01-01";
export const guarantorMinimumAge = 21;
export const qaTag = "data-qa";
export const processRetryCountParam = "processRetryCount";
export const enrollmentApplicationIdParam = "enrollmentApplicationId";
export const metadataCookieParam = "metadata";

